import { BASE_URL } from "../utils/constants";

export const apis = {
    login: `${BASE_URL}/user/login`,
    bsh_url: "https://api-dev.equitygroupholdings.com/adminportalauth/oauth/microsoft",
    backoffice_login: `${BASE_URL}/user/backOffice/login`,
    services_list: `${BASE_URL}/billing/services/all`,
    notifications: `${BASE_URL}/billing/notification/all`,
    notification_requests: `${BASE_URL}/billing/notificationrequests/all`,
    notification_retry: `${BASE_URL}/billing/notificationrequests/edit`,
    create_service: `${BASE_URL}/billing/services/add`,
    ip_test: `${BASE_URL}/billing/telnet`,
    users: `${BASE_URL}/user/fetchUser/all`,
    sms: `${BASE_URL}/billing/sms/list`,
    user_create: `${BASE_URL}/user/add/`,
    user_update: `${BASE_URL}/user/updateUser/`,
    update_config: `${BASE_URL}/billing/integrations/live/edit`,
    test_validation: `${BASE_URL}/billing/biller/validation/post`,
    test_notification: `${BASE_URL}/billing/biller/notification/post`,
    pending_services: `${BASE_URL}/billing/services/pending/all`,
    migrate_service: `${BASE_URL}/billing/services/migrate`,
    create_integration: `${BASE_URL}/billing/integrations/live/add`,
    edit_service: `${BASE_URL}/billing/services/edit`,
    prod_script: `${BASE_URL}/billing/generate/prod/script/`,
    lookup: `${BASE_URL}/billing/lookup/`,
    dashboard: `${BASE_URL}/user/dashboard`,
}